export const visit = (vm, at) => {
vm(require("./availability/sv.lyaml"));
vm(require("./typical-response-time/sv.lyaml"));
vm(require("./default/sv.lyaml"));
at({ "sv": { "conversations-internal-schema": { "we-wont-use-this-key-in-the-product-but-this-file-wont-update-with-new-languages-without-a-key": "okej" } } });
};